<template>
  <div>
    <app-header title="Internal Access List">
      <b-button variant="primary" @click="createUser()">
        New User
      </b-button>
    </app-header>
    <loading-spinner v-if="!users" />
    <b-container v-else>
      <b-card-group columns>
        <b-card v-for="user in users" :key="user.id">
          <b-card-body @click="selectUser(user)" style="cursor: pointer">
            <b-card-title>
              {{ user.email }}
            </b-card-title>
            <p>{{ user.permissions.join(', ') }}</p>
          </b-card-body>
        </b-card>
      </b-card-group>
    </b-container>
    <b-modal
      v-if="activeUser"
      scrollable
      title="Edit User"
      ref="userModal"
    >
            <b-form>
              <b-form-group>
                <b-form-input v-model="activeUser.email" type="text"></b-form-input>
              </b-form-group>
              <div class="form-group">
                <div v-for="permission in permissions" :key="permission.id" class="form-check">
                  <label class="form-check-label">
                    <input v-model="permission.checked" type="checkbox" class="form-check-input">{{ permission.id }}
                  </label>
                </div>
              </div>
            </b-form>
          
          <template v-slot:modal-footer>
            <div class="w-100">
            <b-button type="button" variant="danger" @click="deleteUser()"  class="float-left">
              Remove User
            </b-button>
            
            <b-button type="button" variant="primary" @click="saveUser()" class="float-right">
              Save
            </b-button>
            </div>
          </template>
    </b-modal>
  </div>
</template>
<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  components: {
    AppHeader,
    LoadingSpinner
  },

  data() {
    return {
      activeUser: null,
      users: null,
      permissions: [
        { id: 'qr' },
        { id: 'templates' },
        { id: 'template_tools' },
        { id: 'template_log' },
        { id: 'developer_tools' },
        { id: 'store_credits' },
        { id: 'users' },
        { id: 'media' },
        { id: 'film_types' },
        { id: 'country_settings' },
        { id: 'screen_protector_types' },
        { id: 'distributors' },
        { id: 'translation' },
        { id: 'device_categories' },
        { id: 'fs_credits' },
        { id: 'film_codes' },
        { id: 'machine_control' },
        { id: 'customer_list' },
        { id: 'internal_user_list' },
        { id: 'screensavers' },
      ],
    };
  },
  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.users = await $api.get('/v1/internal/users');
    },

    showModal() {
      this.$refs['userModal'].show();
    },

    killModal() {
      this.$refs['userModal'].hide();
    },

    createUser() {
      this.selectUser({ permissions: [] });
    },

    selectUser(user) {
      this.activeUser = user;
      this.showModal();
      this.permissions.forEach((permission) => {
        permission.checked = (user.permissions.includes(permission.id));
      });
    },

    async saveUser() {
      const permissions = this.permissions.filter((p) => p.checked).map((p) => p.id);
      await $api.put(`/v1/internal/users/${this.activeUser.email}`, { email: this.activeUser.email, permissions });
      this.killModal();
      this.refreshData();
    },

    async deleteUser() {
      await $api.delete(`/v1/internal/users/${this.activeUser.email}`);
      this.killModal();
      this.refreshData();
    },
  },
};
</script>
